import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const alignBreakpointCenterMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Align Center',
		isVisible: ({ controller }): boolean => {
			return !controller.readonly;
		},
		onClick: ({ context, controller }): void => {
			const refMap = controller?.kitchen?.getReferenceMap(context.id);
			refMap?.breakpoint?.snapCenter();
		}
	}
};
